(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'react', 'prop-types', '@emotion/core', 'recompose/onlyUpdateForKeys'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('@emotion/core'), require('recompose/onlyUpdateForKeys'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.core, global.onlyUpdateForKeys);
    global.SyncLoader = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _core, _onlyUpdateForKeys) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _onlyUpdateForKeys2 = _interopRequireDefault(_onlyUpdateForKeys);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var _templateObject = _taggedTemplateLiteral(['\n  33% {transform: translateY(10px)}\n  66% {transform: translateY(-10px)}\n  100% {transform: translateY(0)}\n'], ['\n  33% {transform: translateY(10px)}\n  66% {transform: translateY(-10px)}\n  100% {transform: translateY(0)}\n']);

  function _taggedTemplateLiteral(strings, raw) {
    return Object.freeze(Object.defineProperties(strings, {
      raw: {
        value: Object.freeze(raw)
      }
    }));
  }

  var sync = (0, _core.keyframes)(_templateObject);

  var Loader = function (_React$Component) {
    _inherits(Loader, _React$Component);

    function Loader() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Loader);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Loader.__proto__ || Object.getPrototypeOf(Loader)).call.apply(_ref, [this].concat(args))), _this), _this.style = function (i) {
        var _this$props = _this.props,
            color = _this$props.color,
            size = _this$props.size,
            sizeUnit = _this$props.sizeUnit,
            margin = _this$props.margin;


        return (0, _core.css)('{background-color:', color, ';width:', '' + size + sizeUnit, ';height:', '' + size + sizeUnit, ';margin:', margin, ';border-radius:100%;display:inline-block;animation:', sync, ' 0.6s ', i * 0.07, 's infinite ease-in-out;animation-fill-mode:both;}label:style;' + (process.env.NODE_ENV === 'production' ? '' : '/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */'));
      }, _this.wrapper = function () {
        return _this.props.css || '';
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Loader, [{
      key: 'render',
      value: function render() {
        var loading = this.props.loading;


        return loading ? (0, _core.jsx)(
          'div',
          { css: this.wrapper() },
          (0, _core.jsx)('div', { css: this.style(1) }),
          (0, _core.jsx)('div', { css: this.style(2) }),
          (0, _core.jsx)('div', { css: this.style(3) })
        ) : null;
      }
    }]);

    return Loader;
  }(_react2.default.Component);

  Loader.propTypes = {
    loading: _propTypes2.default.bool,
    color: _propTypes2.default.string,
    size: _propTypes2.default.number,
    margin: _propTypes2.default.string,
    sizeUnit: _propTypes2.default.string,
    css: _propTypes2.default.string
  };

  Loader.defaultProps = {
    loading: true,
    color: '#000000',
    size: 15,
    margin: '2px',
    sizeUnit: 'px',
    css: ''
  };

  var Component = (0, _onlyUpdateForKeys2.default)(['loading', 'color', 'size', 'margin', 'sizeUnit', 'css'])(Loader);
  Component.defaultProps = Loader.defaultProps;
  exports.default = Component;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-spinners/SyncLoader.js
// module id = 282
// module chunks = 0